import { API_BASE_URL, TPS_API_BASE_URL } from "../utils/apiConfig";

export const USE_MOCK_API = process.env.REACT_APP_USE_MOCK_API === "true";

const apiBaseUrl = API_BASE_URL.replace(/\/$/, "");
const tpsApiBaseUrl = TPS_API_BASE_URL.replace(/\/$/, "");

export const API_ENDPOINTS = {
  findGroupJourneys: `${tpsApiBaseUrl}/api/v1/Journeys/FindForGroup`,
  findPoints: `${tpsApiBaseUrl}/api/v1/Points/Find`,

  sendGroupTravelApplication: `${apiBaseUrl}/api/v1/GroupTravel/SendApplication`,
  unregisterGroupTravel: `${apiBaseUrl}/api/v1/GroupTravel/Cancel`,

  getTravelDetails: (referenceId: string, editId: string) =>
    `${apiBaseUrl}/api/v1/GroupTravel/GetDetails?referenceId=${encodeURIComponent(
      referenceId
    )}&editId=${encodeURIComponent(editId)}`,
};
